<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height class="layout-background">
        <slot />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {}
</script>

<style scoped>
.layout-background {
  background: linear-gradient(
    90deg,
    rgba(15, 12, 43, 0.9) 0%,
    rgba(15, 12, 43, 0.9) 100%,
    rgba(16, 13, 44, 0.9) 100%,
    rgb(0, 212, 255) 100%
  );
}
</style>
